/**
 * Générateur — Automatisme : utiliser la réciproque du théorème de Thalès
 * pour démontrer que deux droites sont parallèles en s'appuyant sur des
 * rapports de longueurs.
 * Attendu ID : 1087 | Niveau : 4ème | Domaine : Espace et géométrie, géométrie plane
 * Rubrique : AUTOMATISME (créé par le professeur, gen neuf du 2026-09-24).
 *
 * ── D'où vient l'intitulé ─────────────────────────────────────────────────
 * Le BO 2025 met la réciproque de Thalès en 3e (cycle 4 l. 1104-1105) ; le
 * professeur la garde en 4e (repères annuels 2019 : « Le théorème de Thalès
 * et sa réciproque dans la configuration des triangles emboîtés sont
 * énoncés et utilisés »). Ligne servie, qui fait plafond : Eduscol, attendus
 * de fin de 4e (2019) l. 433 « Il démontre le parallélisme de deux droites
 * en s'appuyant sur des rapports de longueurs. » Le mot « contraposée »
 * n'est jamais prononcé (décision prof 24/09) : la phrase du cours, « On ne
 * peut pas utiliser la réciproque du théorème de Thalès. Les droites … ne
 * sont pas parallèles. »
 *
 * ── Cadrage (sous-agent programme-maths 2026-09-24, décisions prof) ───────
 * La méthode du cours (19Thales4 p. 3-4, fiches 6 et 7 du prof) : « D'une
 * part CB/CE = 3/4 = 0,75 ; D'autre part CA/CD = 4,5/6 = 0,75 ; Donc … ;
 * De plus, les points … sont alignés dans le même ordre que … ; D'après la
 * réciproque du théorème de Thalès, les droites … sont parallèles. » Les
 * DEUX issues, un tirage sur deux. Seuls les deux rapports depuis le sommet
 * entrent en jeu (jamais MN et BC). Rapports à écriture décimale exacte,
 * au centième au plus : 0,25 ; 0,3 ; 0,4 ; 0,5 ; 0,6 ; 0,7 ; 0,75 ; 0,8 (0,2
 * et 0,9 retirés au regard : petit triangle minuscule, ou M collé à B et les noms qui se chevauchent) ; longueurs entières ou à ,5 de 3 à 20, AM et AN d'au moins 1,5,
 * AB ≠ AC. Un « non » : deux rapports de la liste distants de 0,05 à 0,15,
 * et (MN) à 1° à 3° de la direction de (BC) sur la figure exacte : l'œil ne
 * tranche pas, le calcul si. En triangles emboîtés, les points sont
 * toujours « dans le même ordre » : c'est une ligne de la rédaction, pas un
 * cas à trancher (le seul contre-exemple est le papillon, 3e). CALCULATRICE
 * AUTORISÉE sur « Parallèles ou pas ? » et « Les deux rapports » (décision
 * prof 24/09 au soir, « n'oublie pas élève de 4e » : 3,7 ÷ 18,5 ne se fait
 * pas de tête), pas sur la carte où les rapports sont donnés. Rappel
 * brouillon IMPÉRATIF sur les deux cartes de calcul depuis le 25/09 ; pas sur
 * « Les étapes dans l'ordre » (prof 25/09 : « pas besoin de calculer et de
 * brouillon ici », les rapports y sont donnés : exception à la règle par
 * attendu, décidée carte par carte). SACRIFIÉ (fiche à venir) : le quadruplet
 * du cours (3 ; 4 ; 4,5 ; 6).
 *
 * ── Révision 2026-09-25 (retour prof, carte par carte) ───────────────────
 *   - Brouillon impératif (RAPPEL_BROUILLON, juste avant la question) sur
 *     « Parallèles ou pas ? » et « Les deux rapports » ; pas sur les étapes.
 *   - « La conclusion » SUPPRIMÉE : « Parallèles ou pas ? » conclut déjà,
 *     avec la justification (même doublon que dans 1089, décision prof).
 *   - « Les étapes dans l'ordre » : la rédaction commence par l'hypothèse,
 *     « On sait que les points … sont alignés dans le même ordre que les
 *     points … » (à la place du « De plus, … » en quatrième position), dans
 *     les deux issues.
 *
 * ── Cartes ────────────────────────────────────────────────────────────────
 *   « Parallèles ou pas ? » (paralleles_qcm_unique) : figure exacte à
 *     l'encre, quatre longueurs ; quatre réponses justifiées, deux « oui »
 *     et deux « non », les mêmes à chaque tirage (la forme ne trahit rien).
 *   « Les deux rapports » (rapports_texte_trou_saisie) : « D'une part … = ⬚ »,
 *     « D'autre part … = ⬚ » (fiche 6 du prof, ex. 1 a).
 *   « Les étapes dans l'ordre » (etapes_ordonner) : la rédaction du cours,
 *     cinq lignes : on sait que (l'alignement), d'une part, d'autre part,
 *     donc, la conclusion.
 *   Coupées (épreuve de Musk) : le texte à trous en étiquettes (« La
 *   rédaction », redit par « Les étapes ») ; le
 *   quadrillage de la fiche 6 (lire une longueur en carreaux est un autre
 *   geste) ; les problèmes (voile, contrefort, viaduc : calculatrice ou deux
 *   étapes) : 190.
 *
 * ── Erreurs (familles nommées) ───────────────────────────────────────────
 *   direct_pour_reciproque (PRINCIPALE) : « d'après le théorème de Thalès,
 *     elles sont parallèles » (DEPP 2de 2025 q.18 lu en miroir) ;
 *   additif : comparer les écarts (AB − AM et AC − AN) au lieu des rapports ;
 *   reciproque_pour_conclure_non : « d'après la réciproque, elles ne sont
 *     pas parallèles » (le cours : on ne peut pas l'utiliser) ;
 *   conclusion_inversee ; nom_du_theoreme : la réciproque de Pythagore citée
 *     pour des droites parallèles (DEPP q.18 : « confond les noms des
 *     théorèmes »).
 *
 * Hors : le papillon, la contraposée nommée (3e) ; le produit en croix comme
 * test ; les rapports approchés (4/6 ≈ 0,67) ; les morceaux à additionner et
 * « quel outil ? » (190) ; les droites des milieux (1244, 3e).
 */
import {
    randInt, randomChoice, tex,
    makeQcm, makeTexteTrou, makeOrdonner,
} from '../../../utils';
import {
    texDix, tirerLettres, nomsDe, pointsThales, ecartParallele, figureThales,
    phraseAlignes, donnee, rapport,
} from './thales';

const ATTENDU_ID = 1087;
const opts = (label) => ({ niveau: '4eme', matiere: 'maths', attendu: ATTENDU_ID, label });

const L_PARALLELES = 'Parallèles ou pas ?';
const L_RAPPORTS = 'Les deux rapports';
const L_ETAPES = 'Les étapes dans l\'ordre';

// Calculatrice AUTORISÉE sur les cartes de calcul (décision prof 2026-09-24 au soir : « n'oublie pas élève de 4e »).
const calculatrice = (payload) => ({ ...payload, contenu: { ...payload.contenu, calculatrice: true } });
// Rappel brouillon (posé le 2026-09-25) : IMPÉRATIF sur les deux cartes de calcul, juste avant la
// question ; pas sur « Les étapes dans l'ordre » (prof : rien à calculer, les rapports sont donnés).
const RAPPEL_BROUILLON = '<p class="italic text-slate-400">✏️ Pose tes calculs au brouillon.</p>';

/** Les rapports, en centièmes : écriture décimale exacte au centième au plus. */
export const KD = [25, 30, 40, 50, 60, 70, 75, 80];
/** Le quadruplet de la fiche (AM, AB, AN, AC en dixièmes) : jamais tiré. */
export const SACRIFIE = [30, 40, 45, 60];
const range = (a, b) => Array.from({ length: Math.max(0, b - a + 1) }, (_, i) => a + i);
/** Les longueurs (dixièmes, entières ou à ,5, de 3 à 20) dont le produit par k tombe au dixième, d'au moins 1,5. */
const longueursPour = (k) => range(30, 200).filter((d) => d % 5 === 0 && (d * k) % 100 === 0 && (d * k) / 100 >= 15);
/** Centièmes → « 0,8 », « 0,75 ». */
export const frCent = (k) => (k % 10 === 0 ? `0,${k / 10}` : `0,${String(k).padStart(2, '0')}`);
const texCent = (k) => frCent(k).replace(',', '{,}');

/**
 * Une configuration : parallèles (kM = kN) ou non (deux rapports de KD
 * distants de 0,05 à 0,15, (MN) à 1°-3° de (BC) sur la figure exacte).
 */
export const tirerConfiguration = (paralleles) => {
    for (let essai = 0; essai < 1000; essai++) {
        const kM = randomChoice(KD);
        const kN = paralleles ? kM : randomChoice(KD.filter((k) => k !== kM && Math.abs(k - kM) >= 5 && Math.abs(k - kM) <= 15));
        if (kN === undefined) continue;
        const cM = longueursPour(kM); const cN = longueursPour(kN);
        if (!cM.length || !cN.length) continue;
        const AB = randomChoice(cM); const AC = randomChoice(cN);
        if (AB === AC) continue;
        const d = { AM: (AB * kM) / 100, AB, AN: (AC * kN) / 100, AC };
        if ([d.AM, d.AB, d.AN, d.AC].join() === SACRIFIE.join()) continue;
        const L = tirerLettres();
        const alpha = randInt(35, 100);
        const pts = pointsThales({ L, AB, AC, alpha, kM: kM / 100, kN: kN / 100, deg: randInt(0, 23) * 15, miroir: randInt(0, 1) === 1 });
        const ecart = ecartParallele(pts, L);
        if (!paralleles && (ecart < 1 || ecart > 3)) continue;
        return { kM, kN, paralleles: kM === kN, d, L, noms: nomsDe(L), figure: figureThales(pts, L, false), ecart };
    }
    throw new Error('gen_1087 : configuration introuvable');
};

const enonce = (c) => `<p>${phraseAlignes(c.L, true)}</p>`
    + `<p>On donne ${donnee(c.noms.AM, c.d.AM)}, ${donnee(c.noms.AB, c.d.AB)}, ${donnee(c.noms.AN, c.d.AN)} et ${donnee(c.noms.AC, c.d.AC)}.</p>`;
const droites = (c) => `les droites ${tex(`(${c.noms.MN})`)} et ${tex(`(${c.noms.BC})`)}`;
const r1 = (c) => rapport(c.noms.AM, c.noms.AB);
const r2 = (c) => rapport(c.noms.AN, c.noms.AC);

// ─── Carte « Parallèles ou pas ? » (QCM, figure exacte à l'encre) ─────────

const genParalleles = () => {
    const c = tirerConfiguration(randInt(0, 1) === 0); const n = c.noms;
    const choix = [
        { v: `Oui, car ${tex(`${r1(c)} = ${r2(c)}`)} : d'après la réciproque du théorème de Thalès, ${droites(c)} sont parallèles.`, cle: c.paralleles },
        { v: `Non, car ${tex(`${r1(c)} \\neq ${r2(c)}`)} : ${droites(c)} ne sont pas parallèles.`, cle: !c.paralleles },
        { v: 'Oui, d\'après le théorème de Thalès.', cle: false, code: 'direct_pour_reciproque' },
        { v: `Non, car ${tex(`${n.AB} - ${n.AM} \\neq ${n.AC} - ${n.AN}`)}.`, cle: false, code: 'additif' },
    ];
    const bon = choix.find((x) => x.cle).v;
    const texte = enonce(c) + RAPPEL_BROUILLON
        + `<p><b>Les droites ${tex(`(${n.MN})`)} et ${tex(`(${n.BC})`)} sont-elles parallèles ? Choisis la réponse juste et bien justifiée.</b></p>`;
    const payload = makeQcm(choix.map((x) => x.v), bon, texte, { ...opts(L_PARALLELES), elements_additionnels: c.figure });
    payload._meta.params = {
        kM: c.kM, kN: c.kN, paralleles: c.paralleles, d: c.d, ecart: c.ecart,
        distracteurs: [{ code: 'direct_pour_reciproque' }, { code: 'additif' }, { code: 'conclusion_inversee' }],
    };
    return calculatrice(payload);
};

// ─── Carte « Les deux rapports » (saisie guidée) ───────────────────────────

const genRapports = () => {
    const c = tirerConfiguration(randInt(0, 1) === 0);
    const lignes = [
        `$\\text{D'une part : } ${r1(c)} = ${rapport(texDix(c.d.AM), texDix(c.d.AB))} = {{${frCent(c.kM)}}}$`,
        `$\\text{D'autre part : } ${r2(c)} = ${rapport(texDix(c.d.AN), texDix(c.d.AC))} = {{${frCent(c.kN)}}}$`,
    ];
    const texte = enonce(c) + RAPPEL_BROUILLON + '<p><b>Calcule les deux rapports, en écriture décimale.</b></p>';
    const payload = makeTexteTrou(lignes.join('\n'), texte, { ...opts(L_RAPPORTS), mode: 'saisie', elements_additionnels: c.figure });
    payload._meta.params = { kM: c.kM, kN: c.kN, paralleles: c.paralleles, d: c.d };
    return calculatrice(payload);
};

// ─── Carte « Les étapes dans l'ordre » (ordonner) ──────────────────────────

/** La rédaction du cours, l'hypothèse d'abord (prof 25/09) : on sait que, d'une part, d'autre part, donc, la conclusion. */
const genEtapes = () => {
    const c = tirerConfiguration(randInt(0, 1) === 0); const L = c.L;
    const etapes = [
        `On sait que les points ${tex(L.A)}, ${tex(L.M)}, ${tex(L.B)} sont alignés dans le même ordre que les points ${tex(L.A)}, ${tex(L.N)}, ${tex(L.C)}.`,
        `D'une part : ${tex(`${r1(c)} = ${rapport(texDix(c.d.AM), texDix(c.d.AB))} = ${texCent(c.kM)}`)}.`,
        `D'autre part : ${tex(`${r2(c)} = ${rapport(texDix(c.d.AN), texDix(c.d.AC))} = ${texCent(c.kN)}`)}.`,
    ];
    if (c.paralleles) {
        etapes.push(
            `Donc ${tex(`${r1(c)} = ${r2(c)}`)}.`,
            `D'après la réciproque du théorème de Thalès, ${droites(c)} sont parallèles.`,
        );
    } else {
        etapes.push(
            `Donc ${tex(`${r1(c)} \\neq ${r2(c)}`)}.`,
            `On ne peut pas utiliser la réciproque du théorème de Thalès : ${droites(c)} ne sont pas parallèles.`,
        );
    }
    // Pas de rappel brouillon ici (prof 25/09 : « pas besoin de calculer ») : les rapports sont donnés, on range.
    const texte = enonce(c) + `<p>Voici, dans le désordre, les étapes pour savoir si ${droites(c)} sont parallèles.</p>`
        + '<p><b>Remets les étapes dans l\'ordre.</b></p>';
    const payload = makeOrdonner(etapes, texte, { ...opts(L_ETAPES), elements_additionnels: c.figure });
    payload._meta.params = { kM: c.kM, kN: c.kN, paralleles: c.paralleles, d: c.d };
    return payload;
};

// ─── Contrat distracteurs (référence de revue) ────────────────────────────

export const REGLES_DISTRACTEURS_QCM = {
    invariants_communs: [
        'parallèles un tirage sur deux ; rapports de KD ; un « non » à 0,05-0,15 et (MN) à 1°-3° de (BC) sur la figure exacte ; AB ≠ AC ; jamais le quadruplet (3 ; 4 ; 4,5 ; 6) ; lettres saines en KaTeX',
    ],
    paralleles_qcm_unique: 'quatre réponses fixes : oui par la réciproque, non par les rapports différents, direct_pour_reciproque (« oui, d\'après le théorème de Thalès »), additif (« non, car AB − AM ≠ AC − AN », vrai à chaque tirage « oui » puisque AB ≠ AC : le piège de l\'élève qui compare les écarts)',
    supprimees: { conclusion_qcm_unique: 'sortie le 2026-09-25 : « Parallèles ou pas ? » conclut déjà, avec la justification' },
};

// ─── Registre et point d'entrée ───────────────────────────────────────────

const GENERATORS = {
    paralleles_qcm_unique: genParalleles,
    rapports_texte_trou_saisie: genRapports,
    etapes_ordonner: genEtapes,
};

const FORMAT_LABELS = { qcm_unique: 'QCM', texte_trou_saisie: 'Saisie guidée', ordonner: 'Ordonner' };
const buildFormats = (prefix) => Object.keys(GENERATORS).filter((k) => k.startsWith(`${prefix}_`))
    .map((k) => ({ key: k, label: FORMAT_LABELS[k.slice(prefix.length + 1)] || k }));

export const CATEGORIES = [
    { id: 'paralleles', label: L_PARALLELES, formatsList: buildFormats('paralleles') },
    { id: 'rapports', label: L_RAPPORTS, formatsList: buildFormats('rapports') },
    { id: 'etapes', label: L_ETAPES, formatsList: buildFormats('etapes') },
];

export const generate = (typeExercice) => {
    let key;
    if (typeExercice && GENERATORS[typeExercice]) key = typeExercice;
    else if (typeExercice) {
        const matching = Object.keys(GENERATORS).filter((k) => k.startsWith(typeExercice) || k.includes(typeExercice));
        key = matching.length ? randomChoice(matching) : randomChoice(Object.keys(GENERATORS));
    } else key = randomChoice(Object.keys(GENERATORS));
    const payload = GENERATORS[key]();
    payload._meta.generatorKey = key;
    return payload;
};

